import React from 'react';
import { generateKey } from '../../utils/utils.js'


class Video extends React.Component {

  componentDidMount() {
  }

  render() {
    let content = this.props.content;
    let index = this.props.index;
    let videoLink = this.props.content.content[0].value.substr( content.content[0].value.lastIndexOf("\/") +1);
    if (content.content[0].value.includes('youtube')) {
       videoLink  = 'https://www.youtube.com/embed/' + videoLink +'?playsinline=1&modestbranding=1';
    } else if (content.content[0].value.includes('vimeo')) {
      videoLink = 'https://player.vimeo.com/video/' +videoLink +'?playsinline=1&modestbranding=1';
    }
    return (
      <div key={generateKey(index)} className="width-full-width">
          <iframe src={videoLink} title={videoLink}></iframe>
      </div>
    )
  }

}

export default Video;



// WEBPACK FOOTER //
// ./src/Posts/elements/Video.js